import { render, staticRenderFns } from "./ApplyLeader.vue?vue&type=template&id=898d97c4&scoped=true"
import script from "./ApplyLeader.vue?vue&type=script&lang=js"
export * from "./ApplyLeader.vue?vue&type=script&lang=js"
import style0 from "./ApplyLeader.vue?vue&type=style&index=0&id=898d97c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d97c4",
  null
  
)

export default component.exports